import React from 'react'
import {Link} from "react-router-dom"
import {Container, Row, Col} from "react-bootstrap"
import Flash from 'react-reveal/Flash';

function AccessoNonAutorizzato() {
    return (
        

        <Container fluid className="text-center">
            {/* SEZIONE BANNER */}
            <Flash>
        <Container fluid className="head-banner text-white text-center" id="banner_accesso">
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>

            
                <h1>ACCESSO NON AUTORIZZATO.</h1>
                <h3>Ritorna alla <Link to={"/"}>Home</Link></h3>
                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </Flash>
             
            
        </Container>
    )
}

export default AccessoNonAutorizzato;
